import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateUnites } from '../../actions/';

import Compteur from './Compteur';

class NombreUnites extends Component {
    render() {
        const { unites, updateUnites } = this.props;
        return (
            <div className="compteur">
                Nombre d'unités <Compteur cle="unites" value={unites} />{' '}
                <button
                    className="btn btn-sm btn-light"
                    title="Plus"
                    onClick={e => updateUnites(1)}
                >
                    +
                </button>{' '}
                <button
                    className="btn btn-sm btn-light"
                    title="Moins"
                    onClick={e => updateUnites(-1)}
                >
                    -
                </button>
            </div>
        );
    }
}

const mapStateToProps = ({ unites }) => ({ unites });

const mapDispatchToProps = dispatch =>
    bindActionCreators({ updateUnites }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NombreUnites);
